import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import DatePicker from 'react-datepicker';
import Select from 'react-select';
import moment from 'moment';
import swal from 'sweetalert';
import shortid from 'shortid';
import swal2 from 'sweetalert2';
import 'react-datepicker/dist/react-datepicker.css';


import { getBase64, regexValidate, validateNRIC } from '../../utils/common';


class Tab4 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            renewalApplication: props.user.loggedInUser ? (props.user.loggedInUser.Partner_Authority__c === null) : false,
            dob: null,
            houCount: 1,
            Hou: [
                { data: {}, attachment: [] },
            ],
            HouFiles: [],
            isValidHouNric: [],
            houAge: [0],
            otherSourceIncome: [],
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleDOBChange = this.handleDOBChange.bind(this);
        this.addCount = this.addCount.bind(this);
        this.minCount = this.minCount.bind(this);
        this.UpdateHou = this.UpdateHou.bind(this);
        this.handleStartDateChange = this.handleStartDateChange.bind(this);
        this.handleEndDateChange = this.handleEndDateChange.bind(this);
        this.uploadHouFile = this.uploadHouFile.bind(this);
        this.calculateAge = this.calculateAge.bind(this);
        this.removeFile = this.removeFile.bind(this);
        this.onSelect = this.onSelect.bind(this);
    }

    componentWillMount() {
        const { Hou } = this.props.data;
        if (Hou.length > 1) {
            // Check if there is more than one because there's already default data even though it's only { Main_Applicant__c: true }
            const isValidHouNric = Hou.slice(1).map(hou => {
                if (hou.data.ID_Type__c === 'Others') return 'true';
                return validateNRIC(hou.data.ID_Number__c).toString();
            });

            // this.props.data.isValidHouNric = isValidHouNric;
            this.props.changeState('isValidHouNric', isValidHouNric);
            this.setState({
                isValidHouNric,
            });
        }
    }

    componentWillReceiveProps(newProps) {
        if (this.state.renewalApplication) {
            if (newProps.maritalStatus === 'Married') {
                //  this.addCount();
            }

            // if (newProps.data.Hou.length > 0) {
            //     if (newProps.data.Hou[0].hasOwnProperty('data')) {
            //         this.setState({
            //             Hou: newProps.data.Hou,
            //             houCount: newProps.data.Hou.length,
            //         });
            //     }
            // }
        }

        const { Hou } = newProps.data;
        if (Hou.length > 1) {
            // Check if there is more than one because there's already default data even though it's only { Main_Applicant__c: true }
            const isValidHouNric = Hou.slice(1).map(hou => validateNRIC(hou.data.ID_Number__c).toString());
            this.props.data.isValidHouNric = isValidHouNric;

            this.setState({
                Hou,
                houCount: Hou.length,
                isValidHouNric,
            });
        }
    }

    onSelect(selected) {
        if (this.state.otherSourceIncome.length === 0) {
            this.props.changeState('Other_Source_of_Income__c', selected);
            this.props.changeState('Other_Source_of_Income_Amount__c', selected === 'None' ? '0' : '');
            this.setState({ otherSourceIncome: selected });
        } else {
            if (selected.indexOf('None') !== -1) {
                swal({
                    title: 'Cannot choose none.',
                    text: 'Please remove selected options.',
                });
            }
            if (selected !== '' && selected.indexOf('None') === -1) {
                if (this.state.otherSourceIncome.includes('None')) {
                    swal({
                        title: 'Cannot choose more than one.',
                        text: 'Please remove None from selected options.',
                    });
                } else {
                    this.props.changeState('Other_Source_of_Income__c', selected);
                    this.props.changeState('Other_Source_of_Income_Amount__c', '');
                    this.setState({ otherSourceIncome: selected });
                }
            }
            if (selected === '') {
                this.props.changeState('Other_Source_of_Income__c', selected);
                this.props.changeState('Other_Source_of_Income_Amount__c', '');
                this.setState({ otherSourceIncome: selected });
            }
        }
    }

    handleInputChange(event) {
        let { value } = event.target;
        if (event.target.name == 'ID_Number__c') {
            value = value.toUpperCase();
            const isValidId = value !== '' ? validateNRIC(value) : true;
            if (!isValidId) {
                document.getElementById('nric_error0').innerHTML = 'invalid NRIC/FIN format';
            } else {
                document.getElementById('nric_error0').innerHTML = '';
            }
            this.props.data.isValidMainNric = isValidId;
        }
        if (event.target.name === 'Employment_Status__c') {
            this.props.data.HouStatusEmployement[0] = event.target.value;
            if (event.target.value === 'Unemployed') {
                this.props.data.Monthly_Gross_Income__c = 0;
            } else {
                this.props.data.Monthly_Gross_Income__c = '';
            }
        }
        if (event.target.name === 'Monthly_Gross_Income__c' || event.target.name === 'Other_Source_of_Income_Amount__c') {
            // Remove minus sign for main applicant
            value = event.target.value.replace(/-/g, '');
        }
        if (event.target.name === 'Relationship_to_Beneficiary__c') {
            if (value !== 'Others') {
                this.props.changeState('Relationship_to_Beneficiary_Other__c', '');
            }
        }
        if (event.target.id.indexOf('check') !== -1) {
            value = !this.props.data[event.target.name];
        }
        this.props.changeState([event.target.name], value);
    }

    handleDOBChange(date) {
        const newDate = date.format('YYYY-MM-DD').toString();
        // this.props.changeState('Date_of_Birth__c', date.format("YYYY/MM/DD").toString());
        this.setState({
            dob: date,
        });
        this.props.changeState('Date_of_Birth__c', newDate);
    }

    handleStartDateChange(date) {
        const newDate = date.format('YYYY-MM-DD').toString();
        // this.props.changeState('Date_of_Birth__c', date.format("YYYY/MM/DD").toString());
        this.props.changeState('Employment_Start_Date__c', newDate);
    }

    handleEndDateChange(date) {
        const newDate = date.format('YYYY-MM-DD').toString();
        // this.props.changeState('Date_of_Birth__c', date.format("YYYY/MM/DD").toString());
        this.props.changeState('Employment_End_Date__c', newDate);
    }

    addCount() {
        this.setState({
            houCount: (this.state.houCount + 1),
        });
        this.props.data.Hou.push({
            data: {
                ID_Type__c: 'NRIC',
                Gender__c: '',
                Race__c: '',
                Relationship_to_Beneficiary__c: '',
                Monthly_Gross_Income__c: '',
            },
            attachment: {},
        });
        this.setState({
            houAge: [...this.state.houAge, 0],
        });
        this.props.data.HouStatusEmployement.push('');
        this.props.data.isValidHouNric.push('');
    }

    minCount(event) {
        if (this.props.maritalStatus === 'Married' && this.state.houCount === 2) {
            return swal({
                icon: 'warning',
                title: "Cannot Remove Spouse's Biodata",
                text: "Spouse's biodata must be completed",
            });
        }
        const houIdx = Number(event.target.id.match(/\d+/)[0]);
        const { Hou, HouStatusEmployement, isValidHouNric } = this.props.data;

        this.setState({
            houCount: (this.state.houCount - 1),
        });

        Hou.splice(houIdx, 1);
        HouStatusEmployement.splice(houIdx, 1);
        isValidHouNric.splice(houIdx - 1, 1);

        this.props.changeState('Hou', Hou);
        this.props.changeState('HouStatusEmployement', HouStatusEmployement);
        this.props.changeState('isValidHouNric', isValidHouNric);
        // this.props.data.Hou.splice(houIdx, 1);
        // this.props.data.HouStatusEmployement.splice(houIdx, 1);
        // this.props.data.isValidHouNric.splice(houIdx, 1);

        const newHouAge = [...this.state.houAge];
        newHouAge.splice(houIdx, 1);
        this.setState({
            houAge: newHouAge,
        });
    }

    UpdateHou(event) {
        let { value } = event.target;
        const HouList = this.props.data.Hou;
        const houIdx = Number(event.target.id.match(/\d+/)[0]);

        if (event.target.name === 'ID_Type__c') {
            const { isValidHouNric } = this.props.data;

            if (value === 'Others') {
                HouList[houIdx].data.Nationality__c = 'Others';
                HouList[houIdx].data.Other_Nationality__c = '';

                isValidHouNric[houIdx - 1] = 'true';
                document.getElementById(`hou_nric_error${houIdx}`).innerHTML = '';
                // if (isValidHouNric[houIdx - 1]) {
                //     isValidHouNric[houIdx - 1] = 'true';
                // } else {
                //     isValidHouNric.push('true');
                // }
            } else {
                HouList[houIdx].data.Nationality__c = 'Singaporean';
                HouList[houIdx].data.Other_Nationality__c = '';
                const nricStatus = validateNRIC(HouList[houIdx].data.ID_Number__c);

                isValidHouNric[houIdx - 1] = nricStatus.toString();
                document.getElementById(`hou_nric_error${houIdx}`).innerHTML = nricStatus ? '' : 'Invalid format NRIC/FIN';
                // if (isValidHouNric[houIdx - 1]) {
                //     isValidHouNric[houIdx - 1] = nricStatus;
                // } else {
                //     isValidHouNric.push(nricStatus);
                // }
            }

            this.props.changeState('isValidHouNric', isValidHouNric);
        }

        if (event.target.name === 'ID_Number__c') {
            value = value.toUpperCase();
            if (HouList[houIdx].data.ID_Type__c !== 'Others') {
                const isValidNric = validateNRIC(value);
                if (!isValidNric) {
                    document.getElementById(`hou_nric_error${houIdx}`).innerHTML = 'Invalid format NRIC/FIN';
                } else {
                    document.getElementById(`hou_nric_error${houIdx}`).innerHTML = '';
                }
                // this.props.data.isValidHouNric = isValidNric.toString();
                const { isValidHouNric } = this.props.data;
                isValidHouNric[houIdx - 1] = isValidNric.toString();
                // if (isValidHouNric[houIdx - 1]) {
                //     isValidHouNric[houIdx - 1] = isValidNric.toString();
                // } else {
                //     isValidHouNric.push(isValidNric.toString());
                // }

                this.props.changeState('isValidHouNric', isValidHouNric);
            } else {
                document.getElementById(`hou_nric_error${houIdx}`).innerHTML = '';
            }
        }
        if (event.target.name === 'Employment_Status__c') {
            this.props.data.HouStatusEmployement[houIdx] = value;
            if (value === 'Unemployed') {
                HouList[houIdx].data.Monthly_Gross_Income__c = 0;
            } else {
                HouList[houIdx].data.Monthly_Gross_Income__c = '';
            }
        }
        if (event.target.name === 'Relationship_to_Beneficiary__c') {
            if (value !== 'Others') {
                HouList[houIdx].data.Relationship_to_Beneficiary_Other__c = '';
            }
        }
        if (event.target.name === 'Monthly_Gross_Income__c') {
            // Remove minus sign for other household members
            HouList[houIdx].data.Monthly_Gross_Income__c = value.replace(/-/g, '');
        } else {
            HouList[houIdx].data[event.target.name] = value;
        }

        this.setState({
            Hou: HouList,
        });
        this.props.changeState('Hou', HouList);
    }

    async uploadHouFile(event) {
        const { name } = event.target;
        const houIdx = Number(event.target.id.match(/\d+/)[0]);
        const HouList = this.props.data.Hou;
        if (event.target.files[0] !== undefined) {
            const file = event.target.files[0];
            const prefixFile = { file1: 'Nric_Fin_', file2: 'cpmf_statement_', file3: 'payslip_' };
            const fileName = prefixFile[event.target.name] + file.name.replace(/ |-/g, '_');
            const attachment = {
                Name: fileName,
                Body: '',
                parentId: '',
                ContentType: file.type,
            };
            const encodedFile = await getBase64(file);
            attachment.Body = encodedFile.split(',')[1];
            HouList[houIdx].attachment[name] = attachment;
            this.props.changeState('Hou', HouList);
            document.getElementById(`${name}Name${houIdx}`).innerHTML = file.name;
        }
    }

    calculateAge() {
        const birthDate = moment(`${this.props.data.Date_of_Birth__c}`);
        const currentDate = moment();
        const age = currentDate.diff(birthDate);
        const ageInYear = moment.duration(age).years();
        return ageInYear;

        /* const mainYear = this.props.data.Date_of_Birth__c.slice(0, 4);
        const currentYear = new Date().getFullYear();
        const mainAge = currentYear - mainYear;
        return mainAge; */
    }

    removeFile(event) {
        const houId = Number(event.target.id.match(/\d+/)[0]);
        const HouList = this.props.data.Hou;
        let fileNameId = '';
        if (event.target.id.indexOf('file1Name') !== -1) {
            delete HouList[houId].attachment.file1;
            fileNameId = 'file1Name';
        }
        if (event.target.id.indexOf('file2Name') !== -1) {
            delete HouList[houId].attachment.file2;
            fileNameId = 'file2Name';
        }
        if (event.target.id.indexOf('file3Name') !== -1) {
            delete HouList[houId].attachment.file3;
            fileNameId = 'file3Name';
        }
        this.props.changeState('Hou', HouList);
        document.getElementById(`${fileNameId}${houId}`).innerHTML = '';
    }

    render() {
        const that = this;
        const { state, props } = this;

        if (props.data.Hou.length) {
            if (!props.data.Hou[0].data.Main_Applicant__c) {
                props.data.Hou = props.data.Hou.sort((a, b) => {
                    if (a.data.Main_Applicant__c) return 1;
                    if (b.data.Main_Applicant__c) return 1;
                    return -1;
                });
            }
        }

        const relationshipToBeneficiary = (isMainApplicant, i, relationshipType = '') => {
            if (isMainApplicant) {
                return (
                    <select
                        name="Relationship_to_Beneficiary__c"
                        id="Hou[0][Relationship_to_Beneficiary__c]"
                        className="form-control relation1 select"
                        onChange={this.handleInputChange}
                        value={props.data.Relationship_to_Beneficiary__c}
                    >
                        <option value="" />
                        {props.data.householdMemberRelationList.map(rel => <option key={shortid.generate()} value={rel.value}>{rel.label}</option>)}
                    </select>
                );
            }

            return (
                <select
                    name="Relationship_to_Beneficiary__c"
                    id={`Hou${i}[Relationship_to_Beneficiary__c]`}
                    className="form-control relation1 select"
                    onChange={this.UpdateHou}
                    value={relationshipType}
                >
                    <option value="" />
                    {props.data.householdMemberRelationList.map((rel) => {
                        if (rel.value !== 'Self') {
                            return (
                                <option key={shortid.generate()} value={rel.value}>{rel.label}</option>
                            );
                        }
                    })}
                </select>
            );
        };

        // const mainApplicant = props.data.Hou.filter(member => member.data.Main_Applicant__c);
        // const nonMainApplicant = props.data.Hou.filter(member => !member.data.Main_Applicant__c);
        //
        // const householdMembers = [...mainApplicant, ...nonMainApplicant];

        return (
            <div className="col-md-12 print" id="Tab4">

                {/* props.data.Hou.map((householdMember, i) => {
                    return (
                        <div className="fullh" key={i.toString()}>
                            <br />
                            {i === 0 ?
                                <div className="row">
                                    <div className="col-sm-6">
                                        <p><b>Main Applicant</b></p>
                                    </div>
                                </div>
                                :
                                <div className="row">
                                    <div className="col-sm-6">
                                        <b>Member - {i + 1}</b>
                                    </div>
                                    <div className="col-sm-6 right">
                                        <button
                                            className="small"
                                            id={`Ben[${i}][minbutton]`}
                                            onClick={this.minCount}
                                        >
                                            <i id={`Hou[${i}][mincount]`} className="fa fa-minus" />
                                        </button>
                                    </div>
                                </div>
                            }
                            <div className="row ">
                                <div className="col-sm-4">
                                    <div className="form-group">
                                        <label>Full Name <small className="red">(required)</small></label>
                                        <input
                                            onChange={this.UpdateHou}
                                            name="Full_Name__c"
                                            id={`Hou${i}[Full_Name_del__c]`}
                                            type="text"
                                            className="form-control"
                                            value={householdMember.data.Full_Name__c !== undefined ? householdMember.data.Full_Name__c : ''}
                                        />
                                    </div>
                                </div>
                                <div className="col-sm-4">
                                    <div className="form-group">
                                        <label>ID Type <small className="red">(required)</small></label>
                                            <div>
                                                <select
                                                    name="ID_Type__c"
                                                    id={`Hou${i}[ID_Type__c]`}
                                                    className="form-control valid select"
                                                    aria-invalid="false"
                                                    value={householdMember.data.ID_Type__c !== undefined ? householdMember.data.ID_Type__c : ''}
                                                    onChange={this.UpdateHou}
                                                >
                                                    {this.props.data.IDTypeList !== undefined &&
                                                        this.props.data.IDTypeList.map(option => (
                                                            <option key={option.value} value={option.value} className="white">{option.label}</option>
                                                        ))
                                                    }
                                                </select>
                                            </div>
                                    </div>
                                </div>
                                <div className="col-sm-4">
                                    <div className="form-group">
                                        <label>NRIC <small className="red">(required)</small></label>
                                            <div>
                                                <input
                                                    onChange={this.UpdateHou}
                                                    name="ID_Number__c"
                                                    id={`Hou${i}[ID_Number__c]`}
                                                    type="text"
                                                    className="form-control"
                                                    maxLength="30"
                                                    value={householdMember.data.ID_Number__c !== undefined ? householdMember.data.ID_Number__c : ''}
                                                />
                                                <br />
                                                <span id={`hou_nric_error${i}`} style={{ color: 'red' }} />
                                            </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row ">
                                <div className="col-sm-4">
                                    <div className="form-group">
                                        <label>Date of Birth <small className="red">(required)</small></label>
                                            <DatePicker
                                                name="Date_of_Birth__c"
                                                selected={householdMember.data.Date_of_Birth__c ? moment(householdMember.data.Date_of_Birth__c) : null}
                                                dateFormat="DD/MM/YYYY"
                                                onChange={(date) => {
                                                    if (moment() < date) {
                                                        swal({
                                                            type: 'warning',
                                                            title: 'Invalid Date of Birth!',
                                                            text: 'date of birth cannot be future date!',
                                                        });
                                                    } else {
                                                        householdMember.data.Date_of_Birth__c = date.format('YYYY-MM-DD').toString();
                                                        const birthDate = moment(date.format('YYYY-MM-DD').toString());
                                                        const currentDate = moment();
                                                        const age = currentDate.diff(birthDate);
                                                        const ageInYear = moment.duration(age).years();
                                                        const newHouAge = [...state.houAge];
                                                        newHouAge.splice(i, 1, ageInYear);
                                                        this.setState({ houAge: newHouAge });
                                                        that.forceUpdate();
                                                    }
                                                }}
                                                placeholderText="Date of Birth"
                                                className="form-control fullw"
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                            />
                                    </div>
                                </div>
                                <div className="col-sm-4">
                                    <div className="form-group">
                                        <label>Gender <small className="red">(required)</small></label>
                                            <select
                                                onChange={this.UpdateHou}
                                                name="Gender__c"
                                                id={`Hou${i}[Gender__c]`}
                                                type="text"
                                                className="form-control select"
                                                value={householdMember.data.Gender__c !== undefined ? householdMember.data.Gender__c : ''}
                                            >
                                                <option value="" />
                                                <option value="Male">Male</option>
                                                <option value="Female">Female</option>
                                            </select>
                                    </div>
                                </div>
                                <div className="col-sm-4">
                                    <div className="form-group">
                                        <label>Race <small className="red">(required)</small></label>
                                            <select
                                                onChange={this.UpdateHou}
                                                name="Race__c"
                                                id={`Hou${i}[Race__c]`}
                                                type="text"
                                                className="form-control select"
                                                value={householdMember.data.Race__c !== undefined ? householdMember.data.Race__c : ''}
                                            >
                                                <option value="" />
                                                {props.data.raceList !== undefined && props.data.raceList.map(raceItem => (
                                                    <option key={raceItem.value} value={raceItem.value}>{raceItem.label}</option>
                                                ))}
                                            </select>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-4">
                                    <label>Other Race</label>
                                    <div className="form-group">
                                        <div>
                                            <input
                                                onChange={this.UpdateHou}
                                                name="Other_Race__c"
                                                id={`Hou${i}[Other_Race__c]`}
                                                type="text"
                                                className="form-control"
                                                maxLength="9"
                                                value={householdMember.data.Other_Race__c !== undefined && householdMember.data.Race__c === 'Others' ?
                                                    householdMember.data.Other_Race__c : ''}
                                                disabled={householdMember.data.Race__c !== 'Others'}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-4">
                                    <div className="form-group">
                                        <label>Nationality <small className="red">(required)</small></label>
                                            <select
                                                onChange={this.UpdateHou}
                                                name="Nationality__c"
                                                id={`Hou${i}[Nationality__c]`}
                                                type="text"
                                                className="form-control select"
                                                value={householdMember.data.Nationality__c !== undefined ? householdMember.data.Nationality__c : ''}
                                            >
                                                <option value="" />
                                                {props.data.nationList !== undefined && props.data.nationList.map(raceItem => (
                                                    <option key={raceItem.value} value={raceItem.value}>{raceItem.label}</option>
                                                ))}
                                            </select>
                                    </div>
                                </div>
                                <div className="col-sm-4">
                                    <div className="form-group">
                                        <label>Other Nationality</label>
                                            <div>
                                                <input
                                                    onChange={this.UpdateHou}
                                                    name="Other_Nationality__c"
                                                    id={`Hou${i}[Other_Nationality__c]`}
                                                    type="text"
                                                    className="form-control"
                                                    maxLength="9"
                                                    value={householdMember.data.Other_Nationality__c !== undefined && householdMember.data.Nationality__c === 'Others' ?
                                                        householdMember.data.Other_Nationality__c : ''}
                                                    disabled={householdMember.data.Nationality__c !== 'Others'}
                                                />
                                            </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-4">
                                    <div className="form-group">
                                        <label>Relationship to Beneficiary <small className="red">(required)</small></label>
                                            <select
                                                name="Relationship_to_Beneficiary__c"
                                                id={`Hou${i}[Relationship_to_Beneficiary__c]`}
                                                className="form-control relation1 select"
                                                onChange={this.UpdateHou}
                                                value={householdMember.data.Relationship_to_Beneficiary__c ? householdMember.data.Relationship_to_Beneficiary__c : ''}
                                            >
                                                <option value="" />
                                                {props.data.relationList.map((rel) => {
                                                    if (rel.value != 'Self') {
                                                        return (
                                                            <option key={shortid.generate()} value={rel.value}>{rel.label}</option>
                                                        );
                                                    }
                                                })}
                                            </select>
                                    </div>
                                </div>
                                <div className="col-sm-4">
                                    <div className="form-group">
                                        <div>
                                            <label>Gross Monthly Income {householdMember.data.Employment_Status__c !== 'Unemployed' && <small className="red">(required)</small>}
                                                <a href="#" data-toggle="tooltip" title="The gross household income of the individual">
                                                    <img src={require('../../assets/img/question.png')} width="15px" />
                                                </a>
                                            </label>
                                            <input
                                                onChange={this.UpdateHou}
                                                name="Monthly_Gross_Income__c"
                                                id={`Hou${i}[Monthly_Gross_Income__c]`}
                                                type="text"
                                                className="form-control"
                                                value={householdMember.data.Employment_Status__c === 'Unemployed' ? 0 :
                                                    householdMember.data.Monthly_Gross_Income__c}
                                                disabled={householdMember.data.Employment_Status__c === 'Unemployed'}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-4">
                                    <div className="form-group">
                                        <label>Employment Status <small className="red">(required)</small></label>
                                            <select
                                                onChange={this.UpdateHou}
                                                name="Employment_Status__c"
                                                id={`Hou${i}[Employment_Status__c]`}
                                                type="text"
                                                className="form-control select"
                                                value={householdMember.data.Employment_Status__c ? householdMember.data.Employment_Status__c : ''}
                                            >
                                                <option value="" />
                                                {props.data.employStatusList.map(emStat => (
                                                    <option key={emStat.value} value={emStat.value}>{emStat.label}</option>
                                                ))}
                                            </select>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-4">
                                    <div className="form-group">
                                        <div>
                                            <label>Occupation {householdMember.data.Employment_Status__c !== 'Unemployed' && <small className="red">(required)</small>}</label>
                                            <input
                                                onChange={this.UpdateHou}
                                                name="Occupation__c"
                                                id={`Hou${i}[Occupation__c]`}
                                                type="text"
                                                className="form-control select"
                                                value={householdMember.data.Employment_Status__c !== 'Unemployed' ? householdMember.data.Occupation__c : ''}
                                                disabled={householdMember.data.Employment_Status__c === 'Unemployed'}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-4">
                                    <div className="form-group">
                                        <div>
                                            <label>Company {householdMember.data.Employment_Status__c !== 'Unemployed' && <small className="red">(required)</small>}</label>
                                            <input
                                                onChange={this.UpdateHou}
                                                name="Company__c"
                                                id={`Hou${i}[Company__c]`}
                                                type="text"
                                                className="form-control"
                                                value={householdMember.data.Employment_Status__c !== 'Unemployed' ? householdMember.data.Company__c : ''}
                                                disabled={householdMember.data.Employment_Status__c === 'Unemployed'}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-4">
                                    <div className="form-group">
                                        {i === 0 ?
                                            <div>
                                                <label>
                                                    Other Source of Income Amount
                                                    {this.props.data.Other_Source_of_Income__c === 'None' ||
                                                        this.props.data.Other_Source_of_Income__c === '' ?
                                                        '' : <small className="red">(required)</small>
                                                    }
                                                </label>
                                                <input
                                                    onChange={this.handleInputChange}
                                                    name="Other_Source_of_Income_Amount__c"
                                                    id={`Hou${i}[Other_Source_of_Income_Amount__c]`}
                                                    type="text"
                                                    className="form-control"
                                                    value={props.data.Other_Source_of_Income_Amount__c}
                                                    disabled={this.props.data.Other_Source_of_Income__c === 'None'}
                                                />
                                            </div> : ''
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-4">
                                    <div className="form-group">
                                        <label>Upload NRIC/Birth Cert File</label><br />
                                        <label className="fileContainer">
                                            Choose File
                                            <input
                                                onChange={that.uploadHouFile}
                                                onClick={(e) => { e.target.value = null; }}
                                                type="file"
                                                name="file1"
                                                className="form-control-file"
                                                id={`Hou${i}[nric_fin_file]`}
                                                aria-describedby="fh1"
                                            />
                                        </label>
                                        <br />
                                        &nbsp;
                                        <span id={`file1Name${i}`} style={{ fontSize: '10pt', fontWeight: 'bold' }}>
                                            {householdMember.attachment.file1 ? householdMember.attachment.file1.Name : ''}
                                        </span>
                                        <i
                                            id={`Hou${i}[file1Name]`}
                                            className="fa fa-times-circle"
                                            onClick={that.removeFile}
                                        />
                                        <br />
                                        <label>
                                            <small id="fileHelp1" className="form-text text-muted">format: jpg, png, pdf only </small>
                                        </label>
                                    </div>
                                </div>
                                <div className="col-sm-4">
                                    <div className="form-group">
                                        <label>
                                            Upload Past 6 Months CPF Statement
                                        </label>
                                        <br />
                                        <label className="fileContainer">
                                            Choose File
                                            <input
                                                onChange={that.uploadHouFile}
                                                onClick={(e) => { e.target.value = null; }}
                                                name="file2"
                                                type="file"
                                                className="form-control-file"
                                                id={`Hou${i}[cpmf_statement]`}
                                                aria-describedby="gh1"
                                            />
                                        </label>
                                        <br />
                                        &nbsp;
                                        <span id={`file2Name${i}`} style={{ fontSize: '10pt', fontWeight: 'bold' }}>
                                            {householdMember.attachment.file2 ? householdMember.attachment.file2.Name : ''}
                                        </span>
                                        <i
                                            id={`Hou${i}[file2Name]`}
                                            name="file2"
                                            className="fa fa-times-circle"
                                            onClick={that.removeFile}
                                        />
                                        <br />
                                        <label>
                                            <small id="gh1" className="form-text text-muted">format: jpg, png, pdf only </small>
                                        </label>
                                    </div>
                                </div>
                                <div className="col-sm-4">
                                    <div className="form-group">
                                        <label>Upload latest payslip {householdMember.data.Employment_Status__c !== 'Unemployed'}</label>
                                        <br />
                                        <label className="fileContainer">
                                            Choose File
                                            <input
                                                onChange={that.uploadHouFile}
                                                onClick={(e) => { e.target.value = null; }}
                                                type="file"
                                                name="file3"
                                                className="form-control-file"
                                                id={`Hou${i}[payslip]`}
                                                aria-describedby="fh1"
                                            />
                                        </label>
                                        <br />
                                        &nbsp;
                                        <span id={`file3Name${i}`} style={{ fontSize: '10pt', fontWeight: 'bold' }}>
                                            {householdMember.attachment.file3 ? householdMember.attachment.file3.Name : ''}
                                        </span>
                                        <i
                                            id={`Hou${i}[file3Name]`}
                                            name="file2"
                                            className="fa fa-times-circle"
                                            onClick={that.removeFile}
                                        />
                                        <br />
                                        <label>
                                            <small id="fileHelp1" className="form-text text-muted"> format: jpg, png, pdf only </small>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                }) */}

                {props.data.Hou.map((householdMember, i) => {
                    return (
                        <div className="fullh" key={i.toString()}>
                            <br />
                            {householdMember.data.Main_Applicant__c ?
                                <div className="row">
                                    <div className="col-sm-6">
                                        <p><b>Main Applicant</b></p>
                                    </div>
                                </div>
                                :
                                <div className="row">
                                    <div className="col-sm-6">
                                        <b>Member - {i + 1}</b>
                                    </div>
                                    <div className="col-sm-6 right">
                                        <button
                                            className="small"
                                            id={`Ben[${i}][minbutton]`}
                                            onClick={this.minCount}
                                        >
                                            <i id={`Hou[${i}][mincount]`} className="fa fa-minus" />
                                        </button>
                                    </div>
                                </div>
                            }
                            <div className="row ">
                                <div className="col-sm-4">
                                    <div className="form-group">
                                        <label>Full Name <small className="red">(required)</small></label>
                                        {householdMember.data.Main_Applicant__c ?
                                            <input
                                                onChange={this.handleInputChange}
                                                name="Full_Name__c"
                                                id={`Hou${i}[Full_Name_del__c]`}
                                                type="text"
                                                className="form-control"
                                                placeholder="Fullname"
                                                value={props.data.Full_Name__c}
                                                disabled
                                            /> :
                                            <input
                                                onChange={this.UpdateHou}
                                                name="Full_Name__c"
                                                id={`Hou${i}[Full_Name_del__c]`}
                                                type="text"
                                                className="form-control"
                                                value={householdMember.data.Full_Name__c !== undefined ? householdMember.data.Full_Name__c : ''}
                                            />
                                        }
                                    </div>
                                </div>
                                <div className="col-sm-4">
                                    <div className="form-group">
                                        <label>ID Type <small className="red">(required)</small></label>
                                        {householdMember.data.Main_Applicant__c ?
                                            <div>
                                                <select
                                                    name="ID_Type__c"
                                                    id={`Hou${i}[ID_Type__c]`}
                                                    className="form-control valid select"
                                                    aria-invalid="false"
                                                    value={props.data.ID_Type__c}
                                                    onChange={this.handleInputChange}
                                                    disabled
                                                >
                                                    {this.props.data.IDTypeList !== undefined &&
                                                        this.props.data.IDTypeList.map(option => (
                                                            <option key={option.value} value={option.value} className="white">{option.label}</option>
                                                        ))
                                                    }
                                                </select>
                                            </div> :
                                            <div>
                                                <select
                                                    name="ID_Type__c"
                                                    id={`Hou${i}[ID_Type__c]`}
                                                    className="form-control valid select"
                                                    aria-invalid="false"
                                                    value={householdMember.data.ID_Type__c !== undefined ? householdMember.data.ID_Type__c : ''}
                                                    onChange={this.UpdateHou}
                                                >
                                                    {this.props.data.IDTypeList !== undefined &&
                                                        this.props.data.IDTypeList.map(option => (
                                                            <option key={option.value} value={option.value} className="white">{option.label}</option>
                                                        ))
                                                    }
                                                </select>
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div className="col-sm-4">
                                    <div className="form-group">
                                        <label>NRIC <small className="red">(required)</small></label>
                                        {householdMember.data.Main_Applicant__c ?
                                            <div>
                                                <input
                                                    onChange={this.handleInputChange}
                                                    name="ID_Number__c"
                                                    id={`Hou${i}[ID_Number__c]`}
                                                    type="text"
                                                    className="form-control"
                                                    value={props.data.ID_Number__c}
                                                    disabled
                                                />
                                                <br />
                                                <span id="nric_error0" style={{ color: 'red' }} />
                                            </div> :
                                            <div>
                                                <input
                                                    onChange={this.UpdateHou}
                                                    name="ID_Number__c"
                                                    id={`Hou${i}[ID_Number__c]`}
                                                    type="text"
                                                    className="form-control"
                                                    maxLength="30"
                                                    value={householdMember.data.ID_Number__c !== undefined ? householdMember.data.ID_Number__c : ''}
                                                />
                                                <br />
                                                <span id={`hou_nric_error${i}`} style={{ color: 'red' }} />
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="row ">
                                <div className="col-sm-4">
                                    <div className="form-group">
                                        <label>Date of Birth <small className="red">(required)</small></label>
                                        {householdMember.data.Main_Applicant__c ?
                                            <DatePicker
                                                name="Date_of_Birth__c"
                                                selected={props.data.Date_of_Birth__c !== '' ?
                                                    moment(props.data.Date_of_Birth__c) : null}
                                                dateFormat="DD/MM/YYYY"
                                                onChange={this.handleDOBChange}
                                                placeholderText="Date of Birth"
                                                className="form-control fullw"
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                                disabled
                                            /> :
                                            <DatePicker
                                                name="Date_of_Birth__c"
                                                selected={householdMember.data.Date_of_Birth__c ? moment(householdMember.data.Date_of_Birth__c) : null}
                                                dateFormat="DD/MM/YYYY"
                                                onChange={(date) => {
                                                    if (moment() < date) {
                                                        swal({
                                                            type: 'warning',
                                                            title: 'Invalid Date of Birth!',
                                                            text: 'date of birth cannot be future date!',
                                                        });
                                                    } else {
                                                        householdMember.data.Date_of_Birth__c = date.format('YYYY-MM-DD').toString();
                                                        const birthDate = moment(date.format('YYYY-MM-DD').toString());
                                                        const currentDate = moment();
                                                        const age = currentDate.diff(birthDate);
                                                        const ageInYear = moment.duration(age).years();
                                                        const newHouAge = [...state.houAge];

                                                        newHouAge.splice(i, 1, ageInYear);
                                                        this.setState({ houAge: newHouAge });

                                                        const { Hou } = this.props.data;
                                                        Hou[i] = householdMember;
                                                        this.props.changeState('Hou', Hou);
                                                        // that.forceUpdate();
                                                    }
                                                }}
                                                placeholderText="Date of Birth"
                                                className="form-control fullw"
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                            />
                                        }
                                    </div>
                                </div>
                                <div className="col-sm-4">
                                    <div className="form-group">
                                        <label>Gender <small className="red">(required)</small></label>
                                        {householdMember.data.Main_Applicant__c ?
                                            <select
                                                onChange={this.handleInputChange}
                                                name="Gender__c"
                                                id={`Hou${i}[Gender__c]`}
                                                type="text"
                                                className="form-control select"
                                                value={props.data.Gender__c}
                                                disabled
                                            >
                                                <option value="Male">Male</option>
                                                <option value="Female">Female</option>
                                            </select>
                                            :
                                            <select
                                                onChange={this.UpdateHou}
                                                name="Gender__c"
                                                id={`Hou${i}[Gender__c]`}
                                                type="text"
                                                className="form-control select"
                                                value={householdMember.data.Gender__c !== undefined ? householdMember.data.Gender__c : ''}
                                            >
                                                <option value="" />
                                                <option value="Male">Male</option>
                                                <option value="Female">Female</option>
                                            </select>
                                        }
                                    </div>
                                </div>
                                <div className="col-sm-4">
                                    <div className="form-group">
                                        <label>Race <small className="red">(required)</small></label>
                                        {householdMember.data.Main_Applicant__c ?
                                            <select
                                                onChange={this.handleInputChange}
                                                name="Race__c"
                                                id={`Hou${i}[Race__c]`}
                                                type="text"
                                                className="form-control select"
                                                placeholder="Race"
                                                value={props.data.Race__c}
                                                disabled
                                            >
                                                <option value="" />
                                                {props.data.raceList !== undefined && props.data.raceList.map(raceItem => (
                                                    <option key={raceItem.value} value={raceItem.value}>{raceItem.label}</option>
                                                ))}
                                            </select>
                                            :
                                            <select
                                                onChange={this.UpdateHou}
                                                name="Race__c"
                                                id={`Hou${i}[Race__c]`}
                                                type="text"
                                                className="form-control select"
                                                value={householdMember.data.Race__c !== undefined ? householdMember.data.Race__c : ''}
                                            >
                                                <option value="" />
                                                {props.data.raceList !== undefined && props.data.raceList.map(raceItem => (
                                                    <option key={raceItem.value} value={raceItem.value}>{raceItem.label}</option>
                                                ))}
                                            </select>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-4">
                                    <label>Other Race</label>
                                    <div className="form-group">
                                        {i === 0 ?
                                            <div>
                                                <input
                                                    onChange={this.handleInputChange}
                                                    name="Other_Race__c"
                                                    id={`Hou${i}[Other_Race__c]`}
                                                    type="text"
                                                    className="form-control select"
                                                    value={props.data.Other_Race__c}
                                                    disabled
                                                />
                                            </div> :
                                            <div>
                                                <input
                                                    onChange={this.UpdateHou}
                                                    name="Other_Race__c"
                                                    id={`Hou${i}[Other_Race__c]`}
                                                    type="text"
                                                    className="form-control"
                                                    maxLength="30"
                                                    value={householdMember.data.Other_Race__c !== undefined && householdMember.data.Race__c === 'Others' ?
                                                        householdMember.data.Other_Race__c : ''}
                                                    disabled={householdMember.data.Race__c !== 'Others'}
                                                />
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div className="col-sm-4">
                                    <div className="form-group">
                                        <label>Nationality <small className="red">(required)</small></label>
                                        {i == 0 ?
                                            <select
                                                onChange={this.handleInputChange}
                                                name="Nationality__c"
                                                id={`Hou${i}[Nationality__c]`}
                                                type="text"
                                                className="form-control select"
                                                placeholder="Nationality"
                                                value={props.data.Nationality__c}
                                                disabled
                                            >
                                                {props.data.nationList !== undefined && props.data.nationList.map(raceItem => (
                                                    <option key={raceItem.value} value={raceItem.value}>{raceItem.label}</option>
                                                ))}
                                            </select>
                                            :
                                            <select
                                                onChange={this.UpdateHou}
                                                name="Nationality__c"
                                                id={`Hou${i}[Nationality__c]`}
                                                type="text"
                                                className="form-control select"
                                                value={householdMember.data.Nationality__c !== undefined ? householdMember.data.Nationality__c : ''}
                                            >
                                                <option value="" />
                                                {props.data.nationList !== undefined && props.data.nationList.map(raceItem => (
                                                    <option key={raceItem.value} value={raceItem.value}>{raceItem.label}</option>
                                                ))}
                                            </select>
                                        }
                                    </div>
                                </div>
                                <div className="col-sm-4">
                                    <div className="form-group">
                                        <label>Other Nationality</label>
                                        {i == 0 ?
                                            <div>
                                                <input
                                                    onChange={this.handleInputChange}
                                                    name="Other_Nationality__c"
                                                    id={`Hou${i}[Other_Nationality__c]`}
                                                    type="text"
                                                    className="form-control select"
                                                    value={props.data.Other_Nationality__c}
                                                    disabled
                                                />
                                            </div> :
                                            <div>
                                                <input
                                                    onChange={this.UpdateHou}
                                                    name="Other_Nationality__c"
                                                    id={`Hou${i}[Other_Nationality__c]`}
                                                    type="text"
                                                    className="form-control"
                                                    maxLength="30"
                                                    value={householdMember.data.Other_Nationality__c !== undefined && householdMember.data.Nationality__c === 'Others' ?
                                                        householdMember.data.Other_Nationality__c : ''}
                                                    disabled={householdMember.data.Nationality__c !== 'Others'}
                                                />
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-4">
                                    <div className="form-group">
                                        <label>Relationship to Beneficiary <small className="red">(required)</small></label>
                                        {relationshipToBeneficiary(
                                            householdMember.data.Main_Applicant__c,
                                            i,
                                            householdMember.data.Relationship_to_Beneficiary__c
                                        )}
                                    </div>
                                </div>
                                <div className="col-sm-4">
                                    <div className="form-group">
                                        <label>Other Relationship</label>
                                        {i == 0 ?
                                            <div>
                                                <input
                                                    onChange={this.handleInputChange}
                                                    name="Relationship_to_Beneficiary_Other__c"
                                                    id={`Hou${i}[Relationship_to_Beneficiary_Other__c]`}
                                                    type="text"
                                                    className="form-control select"
                                                    value={props.data.Relationship_to_Beneficiary_Other__c}
                                                    disabled={props.data.Relationship_to_Beneficiary__c !== 'Others'}
                                                    maxLength="255"
                                                />
                                            </div> :
                                            <div>
                                                <input
                                                    onChange={this.UpdateHou}
                                                    name="Relationship_to_Beneficiary_Other__c"
                                                    id={`Hou${i}[Relationship_to_Beneficiary_Other__c]`}
                                                    type="text"
                                                    className="form-control"
                                                    value={householdMember.data.Relationship_to_Beneficiary_Other__c !== undefined && householdMember.data.Relationship_to_Beneficiary__c === 'Others' ?
                                                        householdMember.data.Relationship_to_Beneficiary_Other__c : ''}
                                                    disabled={householdMember.data.Relationship_to_Beneficiary__c !== 'Others'}
                                                    maxLength="255"
                                                />
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div className="col-sm-4">
                                    <div className="form-group">
                                        {i == 0 ?
                                            <div>
                                                <label>Gross Monthly Income {props.data.Employment_Status__c !== 'Unemployed' && <small className="red">(required)</small>}
                                                    <a href="#" data-toggle="tooltip" title="The gross household income of the individual">
                                                        <img src={require('../../assets/img/question.png')} width="15px" />
                                                    </a>
                                                </label>
                                                <input
                                                    onChange={this.handleInputChange}
                                                    name="Monthly_Gross_Income__c"

                                                    id={`Hou${i}[Monthly_Gross_Income__c]`}
                                                    type="number"
                                                    min="0"
                                                    className="form-control"
                                                    value={props.data.Employment_Status__c === 'Unemployed' ? 0 :
                                                        props.data.Monthly_Gross_Income__c}
                                                    disabled={props.data.Employment_Status__c === 'Unemployed'}
                                                />
                                            </div> :
                                            <div>
                                                <label>Gross Monthly Income {householdMember.data.Employment_Status__c !== 'Unemployed' && <small className="red">(required)</small>}
                                                    <a href="#" data-toggle="tooltip" title="The gross household income of the individual">
                                                        <img src={require('../../assets/img/question.png')} width="15px" />
                                                    </a>
                                                </label>
                                                <input
                                                    onChange={this.UpdateHou}
                                                    name="Monthly_Gross_Income__c"
                                                    id={`Hou${i}[Monthly_Gross_Income__c]`}
                                                    type="number"
                                                    className="form-control"
                                                    value={householdMember.data.Employment_Status__c === 'Unemployed' ? 0 :
                                                        householdMember.data.Monthly_Gross_Income__c}
                                                    disabled={householdMember.data.Employment_Status__c === 'Unemployed'}
                                                />
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                            {
                                householdMember.data.Main_Applicant__c ?
                                    <div className="row">
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                                <label>Employment Status <small className="red">(required)</small></label>
                                                {i == 0 ?
                                                    <select
                                                        onChange={this.handleInputChange}
                                                        name="Employment_Status__c"
                                                        id={`Hou${i}[Employment_Status__c]`}
                                                        type="text"
                                                        className="form-control select"
                                                        value={props.data.Employment_Status__c}
                                                    >
                                                        <option value="" />
                                                        {props.data.employStatusList.map(emStat => (
                                                            <option key={emStat.value} value={emStat.value}>{emStat.label}</option>
                                                        ))}
                                                    </select> :
                                                    <select
                                                        onChange={this.UpdateHou}
                                                        name="Employment_Status__c"
                                                        id={`Hou${i}[Employment_Status__c]`}
                                                        type="text"
                                                        className="form-control select"
                                                        value={householdMember.data.Employment_Status__c ? householdMember.data.Employment_Status__c : ''}
                                                    >
                                                        <option value="" />
                                                        {props.data.employStatusList.map(emStat => (
                                                            <option key={emStat.value} value={emStat.value}>{emStat.label}</option>
                                                        ))}
                                                    </select>
                                                }
                                            </div>
                                        </div>
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                                <div>
                                                    <label>Other Source of Income <small className="red">(required)</small></label>
                                                    <Select
                                                        onChange={that.onSelect}
                                                        name="Other_Source_of_Income__c"
                                                        id={`Hou${i}[Other_Source_of_Income__c]`}
                                                        type="text"
                                                        multi
                                                        simpleValue
                                                        options={props.data.OtherSourceIncList}
                                                        value={props.data.Other_Source_of_Income__c}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                                <div>
                                                    <label>
                                                        Other Source of Income Amount
                                                    {this.props.data.Other_Source_of_Income__c === 'None' ||
                                                            this.props.data.Other_Source_of_Income__c === '' ?
                                                            '' : <small className="red">(required)</small>
                                                        }
                                                    </label>
                                                    <input
                                                        onChange={this.handleInputChange}
                                                        name="Other_Source_of_Income_Amount__c"
                                                        id={`Hou${i}[Other_Source_of_Income_Amount__c]`}
                                                        type="number"
                                                        min="0"
                                                        className="form-control"
                                                        value={props.data.Other_Source_of_Income_Amount__c}
                                                        disabled={this.props.data.Other_Source_of_Income__c === 'None'}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div> :
                                    <div className="row">
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                                <label>Employment Status <small className="red">(required)</small></label>
                                                {i == 0 ?
                                                    <select
                                                        onChange={this.handleInputChange}
                                                        name="Employment_Status__c"
                                                        id={`Hou${i}[Employment_Status__c]`}
                                                        type="text"
                                                        className="form-control select"
                                                        value={props.data.Employment_Status__c}
                                                    >
                                                        <option value="" />
                                                        {props.data.employStatusList.map(emStat => (
                                                            <option key={emStat.value} value={emStat.value}>{emStat.label}</option>
                                                        ))}
                                                    </select> :
                                                    <select
                                                        onChange={this.UpdateHou}
                                                        name="Employment_Status__c"
                                                        id={`Hou${i}[Employment_Status__c]`}
                                                        type="text"
                                                        className="form-control select"
                                                        value={householdMember.data.Employment_Status__c ? householdMember.data.Employment_Status__c : ''}
                                                    >
                                                        <option value="" />
                                                        {props.data.employStatusList.map(emStat => (
                                                            <option key={emStat.value} value={emStat.value}>{emStat.label}</option>
                                                        ))}
                                                    </select>
                                                }
                                            </div>
                                        </div>
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                                <div>
                                                    <label>Occupation {householdMember.data.Employment_Status__c !== 'Unemployed' && <small className="red">(required)</small>}</label>
                                                    <input
                                                        onChange={this.UpdateHou}
                                                        name="Occupation__c"
                                                        id={`Hou${i}[Occupation__c]`}
                                                        type="text"
                                                        className="form-control select"
                                                        value={householdMember.data.Employment_Status__c !== 'Unemployed' ? householdMember.data.Occupation__c : ''}
                                                        disabled={householdMember.data.Employment_Status__c === 'Unemployed'}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                                <div>
                                                    <label>Company {householdMember.data.Employment_Status__c !== 'Unemployed' && <small className="red">(required)</small>}</label>
                                                    <input
                                                        onChange={this.UpdateHou}
                                                        name="Company__c"
                                                        id={`Hou${i}[Company__c]`}
                                                        type="text"
                                                        className="form-control"
                                                        value={householdMember.data.Employment_Status__c !== 'Unemployed' ? householdMember.data.Company__c : ''}
                                                        disabled={householdMember.data.Employment_Status__c === 'Unemployed'}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                            }
                            {
                                householdMember.data.Main_Applicant__c ?
                                    <div className="row">
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                                <div>
                                                    <label>Occupation {props.data.Employment_Status__c !== 'Unemployed' && <small className="red">(required)</small>}</label>
                                                    <input
                                                        onChange={this.handleInputChange}
                                                        name="Occupation__c"
                                                        id={`Hou${i}[Occupation__c]`}
                                                        type="text"
                                                        className="form-control select"
                                                        value={props.data.Employment_Status__c === 'Unemployed' ? '' : props.data.Occupation__c}
                                                        disabled={props.data.Employment_Status__c === 'Unemployed'}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                                <div>
                                                    <label>Company {props.data.Employment_Status__c !== 'Unemployed' && <small className="red">(required)</small>}</label>
                                                    <input
                                                        onChange={this.handleInputChange}
                                                        name="Company__c"
                                                        id={`Hou${i}[Company__c]`}
                                                        type="text"
                                                        className="form-control"
                                                        value={props.data.Employment_Status__c === 'Unemployed' ? '' : props.data.Company__c}
                                                        disabled={props.data.Employment_Status__c === 'Unemployed'}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div> : ''
                            }
                            <div className="row">
                                <div className="col-sm-4">
                                    <div className="form-group">
                                        <label>Upload NRIC/Birth Cert File</label><br />
                                        <label className="fileContainer">
                                            Choose File
                                            <input
                                                onChange={that.uploadHouFile}
                                                onClick={(e) => { e.target.value = null; }}
                                                type="file"
                                                name="file1"
                                                className="form-control-file"
                                                id={`Hou${i}[nric_fin_file]`}
                                                aria-describedby="fh1"
                                                accept=".jpeg,.jpg,.png,.pdf,image/jpeg,image/pjpeg,image/png,application/pdf"
                                            />
                                        </label>
                                        <br />
                                        &nbsp;
                                        <span
                                            id={`file1Name${i}`}
                                            style={{ fontSize: '10pt', fontWeight: 'bold', wordBreak: 'break-all' }}
                                        >
                                            {householdMember.attachment.file1 ? householdMember.attachment.file1.Name : ''}
                                        </span>
                                        <i
                                            id={`Hou${i}[file1Name]`}
                                            className="fa fa-times-circle"
                                            onClick={that.removeFile}
                                        />
                                        <br />
                                        <label>
                                            <small id="fileHelp1" className="form-text text-muted">format: jpg, png, pdf only </small>
                                        </label>
                                    </div>
                                </div>
                                <div className="col-sm-4">
                                    <div className="form-group">
                                        <label>
                                            Upload Past 6 Months CPF Statement
                                        </label>
                                        <br />
                                        <label className="fileContainer">
                                            Choose File
                                            <input
                                                onChange={that.uploadHouFile}
                                                onClick={(e) => { e.target.value = null; }}
                                                name="file2"
                                                type="file"
                                                className="form-control-file"
                                                id={`Hou${i}[cpmf_statement]`}
                                                aria-describedby="gh1"
                                                accept=".jpeg,.jpg,.png,.pdf,image/jpeg,image/pjpeg,image/png,application/pdf"
                                            />
                                        </label>
                                        <br />
                                        &nbsp;
                                        <span
                                            id={`file2Name${i}`}
                                            style={{ fontSize: '10pt', fontWeight: 'bold', wordBreak: 'break-all' }}
                                        >
                                            {householdMember.attachment.file2 ? householdMember.attachment.file2.Name : ''}
                                        </span>
                                        <i
                                            id={`Hou${i}[file2Name]`}
                                            name="file2"
                                            className="fa fa-times-circle"
                                            onClick={that.removeFile}
                                        />
                                        <br />
                                        <label>
                                            <small id="gh1" className="form-text text-muted">format: jpg, png, pdf only </small>
                                        </label>
                                    </div>
                                </div>
                                <div className="col-sm-4">
                                    <div className="form-group">
                                        {householdMember.data.Main_Applicant__c ?
                                            <label>Upload latest payslip {props.data.Employment_Status__c !== 'Unemployed'}</label>
                                            :
                                            <label>Upload latest payslip {householdMember.data.Employment_Status__c !== 'Unemployed'}</label>
                                        }
                                        <br />
                                        <label className="fileContainer">
                                            Choose File
                                            <input
                                                onChange={that.uploadHouFile}
                                                onClick={(e) => { e.target.value = null; }}
                                                type="file"
                                                name="file3"
                                                className="form-control-file"
                                                id={`Hou${i}[payslip]`}
                                                aria-describedby="fh1"
                                                accept=".jpeg,.jpg,.png,.pdf,image/jpeg,image/pjpeg,image/png,application/pdf"
                                            />
                                        </label>
                                        <br />
                                        &nbsp;
                                        <span
                                            id={`file3Name${i}`}
                                            style={{ fontSize: '10pt', fontWeight: 'bold', wordBreak: 'break-all' }}
                                        >
                                            {householdMember.attachment.file3 ? householdMember.attachment.file3.Name : ''}
                                        </span>
                                        <i
                                            id={`Hou${i}[file3Name]`}
                                            name="file2"
                                            className="fa fa-times-circle"
                                            onClick={that.removeFile}
                                        />
                                        <br />
                                        <label>
                                            <small id="fileHelp1" className="form-text text-muted"> format: jpg, png, pdf only </small>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}

                {/* Array.apply(0, Array(this.state.houCount)).map((x, i) => {
                    return (
                        <div className="fullh" key={i}>
                            <br />
                            {i === 0 ?
                                <div className="row">
                                    <div className="col-sm-6">
                                        <p><b>Main Applicant</b></p>
                                    </div>
                                </div>
                                :
                                <div className="row">
                                    <div className="col-sm-6">
                                        <b>Member - {i + 1}</b>
                                    </div>
                                    <div className="col-sm-6 right">
                                        <button
                                            className="small"
                                            id={`Ben[${i}][minbutton]`}
                                            onClick={this.minCount}
                                        >
                                            <i id={`Hou[${i}][mincount]`} className="fa fa-minus" />
                                        </button>
                                    </div>
                                </div>
                            }
                            <div className="row ">
                                <div className="col-sm-4">
                                    <div className="form-group">
                                        <label>Full Name <small className="red">(required)</small></label>
                                        {i === 0 ?
                                            <input
                                                onChange={this.handleInputChange}
                                                name="Full_Name__c"
                                                id={`Hou${i}[Full_Name_del__c]`}
                                                type="text"
                                                className="form-control"
                                                placeholder="Fullname"
                                                value={props.data.Full_Name__c}
                                                disabled
                                            /> :
                                            <input
                                                onChange={this.UpdateHou}
                                                name="Full_Name__c"
                                                id={`Hou${i}[Full_Name_del__c]`}
                                                type="text"
                                                className="form-control"
                                                value={props.data.Hou[i].data.Full_Name__c !== undefined ? props.data.Hou[i].data.Full_Name__c : ''}
                                            />
                                        }
                                    </div>
                                </div>
                                <div className="col-sm-4">
                                    <div className="form-group">
                                        <label>ID Type <small className="red">(required)</small></label>
                                        {i === 0 ?
                                            <div>
                                                <select
                                                    name="ID_Type__c"
                                                    id={`Hou${i}[ID_Type__c]`}
                                                    className="form-control valid select"
                                                    aria-invalid="false"
                                                    value={props.data.ID_Type__c}
                                                    onChange={this.handleInputChange}
                                                    disabled
                                                >
                                                    {this.props.data.IDTypeList !== undefined &&
                                                        this.props.data.IDTypeList.map(option => (
                                                            <option key={option.value} value={option.value} className="white">{option.label}</option>
                                                        ))
                                                    }
                                                </select>
                                            </div> :
                                            <div>
                                                <select
                                                    name="ID_Type__c"
                                                    id={`Hou${i}[ID_Type__c]`}
                                                    className="form-control valid select"
                                                    aria-invalid="false"
                                                    value={props.data.Hou[i].data.ID_Type__c !== undefined ? props.data.Hou[i].data.ID_Type__c : ''}
                                                    onChange={this.UpdateHou}
                                                >
                                                    {this.props.data.IDTypeList !== undefined &&
                                                        this.props.data.IDTypeList.map(option => (
                                                            <option key={option.value} value={option.value} className="white">{option.label}</option>
                                                        ))
                                                    }
                                                </select>
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div className="col-sm-4">
                                    <div className="form-group">
                                        <label>NRIC <small className="red">(required)</small></label>
                                        {i === 0 ?
                                            <div>
                                                <input
                                                    onChange={this.handleInputChange}
                                                    name="ID_Number__c"
                                                    id={`Hou${i}[ID_Number__c]`}
                                                    type="text"
                                                    className="form-control"
                                                    value={props.data.ID_Number__c}
                                                    disabled
                                                />
                                                <br />
                                                <span id="nric_error0" style={{ color: 'red' }} />
                                            </div> :
                                            <div>
                                                <input
                                                    onChange={this.UpdateHou}
                                                    name="ID_Number__c"
                                                    id={`Hou${i}[ID_Number__c]`}
                                                    type="text"
                                                    className="form-control"
                                                    maxLength="30"
                                                    value={props.data.Hou[i].data.ID_Number__c !== undefined ? props.data.Hou[i].data.ID_Number__c : ''}
                                                />
                                                <br />
                                                <span id={`hou_nric_error${i}`} style={{ color: 'red' }} />
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="row ">
                                <div className="col-sm-4">
                                    <div className="form-group">
                                        <label>Date of Birth <small className="red">(required)</small></label>
                                        {i === 0 ?
                                            <DatePicker
                                                name="Date_of_Birth__c"
                                                selected={props.data.Date_of_Birth__c !== '' ?
                                                    moment(props.data.Date_of_Birth__c) : null}
                                                dateFormat="DD/MM/YYYY"
                                                onChange={this.handleDOBChange}
                                                placeholderText="Date of Birth"
                                                className="form-control fullw"
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                                disabled
                                            /> :
                                            <DatePicker
                                                name="Date_of_Birth__c"
                                                selected={props.data.Hou[i].data.Date_of_Birth__c ? moment(props.data.Hou[i].data.Date_of_Birth__c) : null}
                                                dateFormat="DD/MM/YYYY"
                                                onChange={(date) => {
                                                    if (moment() < date) {
                                                        swal({
                                                            type: 'warning',
                                                            title: 'Invalid Date of Birth!',
                                                            text: 'date of birth cannot be future date!',
                                                        });
                                                    } else {
                                                        props.data.Hou[i].data.Date_of_Birth__c = date.format('YYYY-MM-DD').toString();
                                                        const birthDate = moment(date.format('YYYY-MM-DD').toString());
                                                        const currentDate = moment();
                                                        const age = currentDate.diff(birthDate);
                                                        const ageInYear = moment.duration(age).years();
                                                        const newHouAge = [...state.houAge];
                                                        newHouAge.splice(i, 1, ageInYear);
                                                        this.setState({ houAge: newHouAge });
                                                        that.forceUpdate();
                                                    }
                                                }}
                                                placeholderText="Date of Birth"
                                                className="form-control fullw"
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                            />
                                        }
                                    </div>
                                </div>
                                <div className="col-sm-4">
                                    <div className="form-group">
                                        <label>Gender <small className="red">(required)</small></label>
                                        {i === 0 ?
                                            <select
                                                onChange={this.handleInputChange}
                                                name="Gender__c"
                                                id={`Hou${i}[Gender__c]`}
                                                type="text"
                                                className="form-control select"
                                                value={props.data.Gender__c}
                                                disabled
                                            >
                                                <option value="Male">Male</option>
                                                <option value="Female">Female</option>
                                            </select>
                                            :
                                            <select
                                                onChange={this.UpdateHou}
                                                name="Gender__c"
                                                id={`Hou${i}[Gender__c]`}
                                                type="text"
                                                className="form-control select"
                                                value={props.data.Hou[i].data.Gender__c !== undefined ? props.data.Hou[i].data.Gender__c : ''}
                                            >
                                                <option value="" />
                                                <option value="Male">Male</option>
                                                <option value="Female">Female</option>
                                            </select>
                                        }
                                    </div>
                                </div>
                                <div className="col-sm-4">
                                    <div className="form-group">
                                        <label>Race <small className="red">(required)</small></label>
                                        {i === 0 ?
                                            <select
                                                onChange={this.handleInputChange}
                                                name="Race__c"
                                                id={`Hou${i}[Race__c]`}
                                                type="text"
                                                className="form-control select"
                                                placeholder="Race"
                                                value={props.data.Race__c}
                                                disabled
                                            >
                                                <option value="" />
                                                {props.data.raceList !== undefined && props.data.raceList.map(raceItem => (
                                                    <option key={raceItem.value} value={raceItem.value}>{raceItem.label}</option>
                                                ))}
                                            </select>
                                            :
                                            <select
                                                onChange={this.UpdateHou}
                                                name="Race__c"
                                                id={`Hou${i}[Race__c]`}
                                                type="text"
                                                className="form-control select"
                                                value={props.data.Hou[i].data.Race__c !== undefined ? props.data.Hou[i].data.Race__c : ''}
                                            >
                                                <option value="" />
                                                {props.data.raceList !== undefined && props.data.raceList.map(raceItem => (
                                                    <option key={raceItem.value} value={raceItem.value}>{raceItem.label}</option>
                                                ))}
                                            </select>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-4">
                                    <label>Other Race</label>
                                    <div className="form-group">
                                        {i == 0 ?
                                            <div>
                                                <input
                                                    onChange={this.handleInputChange}
                                                    name="Other_Race__c"
                                                    id={`Hou${i}[Other_Race__c]`}
                                                    type="text"
                                                    className="form-control select"
                                                    value={props.data.Other_Race__c}
                                                    disabled
                                                />
                                            </div> :
                                            <div>
                                                <input
                                                    onChange={this.UpdateHou}
                                                    name="Other_Race__c"
                                                    id={`Hou${i}[Other_Race__c]`}
                                                    type="text"
                                                    className="form-control"
                                                    maxLength="9"
                                                    value={props.data.Hou[i].data.Other_Race__c !== undefined && props.data.Hou[i].data.Race__c === 'Others' ?
                                                        props.data.Hou[i].data.Other_Race__c : ''}
                                                    disabled={props.data.Hou[i].data.Race__c !== 'Others'}
                                                />
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div className="col-sm-4">
                                    <div className="form-group">
                                        <label>Nationality <small className="red">(required)</small></label>
                                        {i == 0 ?
                                            <select
                                                onChange={this.handleInputChange}
                                                name="Nationality__c"
                                                id={`Hou${i}[Nationality__c]`}
                                                type="text"
                                                className="form-control select"
                                                placeholder="Nationality"
                                                value={props.data.Nationality__c}
                                                disabled
                                            >
                                                {props.data.nationList !== undefined && props.data.nationList.map(raceItem => (
                                                    <option key={raceItem.value} value={raceItem.value}>{raceItem.label}</option>
                                                ))}
                                            </select>
                                            :
                                            <select
                                                onChange={this.UpdateHou}
                                                name="Nationality__c"
                                                id={`Hou${i}[Nationality__c]`}
                                                type="text"
                                                className="form-control select"
                                                value={props.data.Hou[i].data.Nationality__c !== undefined ? props.data.Hou[i].data.Nationality__c : ''}
                                            >
                                                <option value="" />
                                                {props.data.nationList !== undefined && props.data.nationList.map(raceItem => (
                                                    <option key={raceItem.value} value={raceItem.value}>{raceItem.label}</option>
                                                ))}
                                            </select>
                                        }
                                    </div>
                                </div>
                                <div className="col-sm-4">
                                    <div className="form-group">
                                        <label>Other Nationality</label>
                                        {i == 0 ?
                                            <div>
                                                <input
                                                    onChange={this.handleInputChange}
                                                    name="Other_Nationality__c"
                                                    id={`Hou${i}[Other_Nationality__c]`}
                                                    type="text"
                                                    className="form-control select"
                                                    value={props.data.Other_Nationality__c}
                                                    disabled
                                                />
                                            </div> :
                                            <div>
                                                <input
                                                    onChange={this.UpdateHou}
                                                    name="Other_Nationality__c"
                                                    id={`Hou${i}[Other_Nationality__c]`}
                                                    type="text"
                                                    className="form-control"
                                                    maxLength="9"
                                                    value={props.data.Hou[i].data.Other_Nationality__c !== undefined && props.data.Hou[i].data.Nationality__c === 'Others' ?
                                                        props.data.Hou[i].data.Other_Nationality__c : ''}
                                                    disabled={props.data.Hou[i].data.Nationality__c !== 'Others'}
                                                />
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-4">
                                    <div className="form-group">
                                        <label>Relationship to Beneficiary <small className="red">(required)</small></label>
                                        {i === 0 ?
                                            <select
                                                name="Relationship_to_Beneficiary__c"
                                                id="Hou[0][Relationship_to_Beneficiary__c]"
                                                className="form-control relation1 select"
                                                onChange={this.handleInputChange}
                                                value={props.data.Relationship_to_Beneficiary__c}
                                                disabled
                                            >
                                                {props.data.relationList.map(rel => <option key={shortid.generate()} value={rel.value}>{rel.label}</option>)}
                                            </select>
                                            :
                                            <select
                                                name="Relationship_to_Beneficiary__c"
                                                id={`Hou${i}[Relationship_to_Beneficiary__c]`}
                                                className="form-control relation1 select"
                                                onChange={this.UpdateHou}
                                                value={props.data.Hou[i].data.Relationship_to_Beneficiary__c ? props.data.Hou[i].data.Relationship_to_Beneficiary__c : ''}
                                            >
                                                <option value="" />
                                                {props.data.relationList.map((rel) => {
                                                    if (rel.value != 'Self') {
                                                        return (
                                                            <option key={shortid.generate()} value={rel.value}>{rel.label}</option>
                                                        );
                                                    }
                                                })}
                                            </select>
                                        }
                                    </div>
                                </div>
                                <div className="col-sm-4">
                                    <div className="form-group">
                                        {i == 0 ?
                                            <div>
                                                <label>Gross Monthly Income {props.data.Employment_Status__c !== 'Unemployed' && <small className="red">(required)</small>}
                                                    <a href="#" data-toggle="tooltip" title="The gross household income of the individual">
                                                        <img src={require('../../assets/img/question.png')} width="15px" />
                                                    </a>
                                                </label>
                                                <input
                                                    onChange={this.handleInputChange}
                                                    name="Monthly_Gross_Income__c"
                                                    id={`Hou${i}[Monthly_Gross_Income__c]`}
                                                    type="text"
                                                    className="form-control"
                                                    value={props.data.Employment_Status__c === 'Unemployed' ? 0 :
                                                        props.data.Monthly_Gross_Income__c}
                                                    disabled={props.data.Employment_Status__c === 'Unemployed'}
                                                />
                                            </div> :
                                            <div>
                                                <label>Gross Monthly Income {props.data.Hou[i].data.Employment_Status__c !== 'Unemployed' && <small className="red">(required)</small>}
                                                    <a href="#" data-toggle="tooltip" title="The gross household income of the individual">
                                                        <img src={require('../../assets/img/question.png')} width="15px" />
                                                    </a>
                                                </label>
                                                <input
                                                    onChange={this.UpdateHou}
                                                    name="Monthly_Gross_Income__c"
                                                    id={`Hou${i}[Monthly_Gross_Income__c]`}
                                                    type="text"
                                                    className="form-control"
                                                    value={props.data.Hou[i].data.Employment_Status__c === 'Unemployed' ? 0 :
                                                        props.data.Hou[i].data.Monthly_Gross_Income__c}
                                                    disabled={props.data.Hou[i].data.Employment_Status__c === 'Unemployed'}
                                                />
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div className="col-sm-4">
                                    <div className="form-group">
                                        <label>Employment Status <small className="red">(required)</small></label>
                                        {i == 0 ?
                                            <select
                                                onChange={this.handleInputChange}
                                                name="Employment_Status__c"
                                                id={`Hou${i}[Employment_Status__c]`}
                                                type="text"
                                                className="form-control select"
                                                value={props.data.Employment_Status__c}
                                            >
                                                <option value="" />
                                                {props.data.employStatusList.map(emStat => (
                                                    <option key={emStat.value} value={emStat.value}>{emStat.label}</option>
                                                ))}
                                            </select> :
                                            <select
                                                onChange={this.UpdateHou}
                                                name="Employment_Status__c"
                                                id={`Hou${i}[Employment_Status__c]`}
                                                type="text"
                                                className="form-control select"
                                                value={props.data.Hou[i].data.Employment_Status__c ? props.data.Hou[i].data.Employment_Status__c : ''}
                                            >
                                                <option value="" />
                                                {props.data.employStatusList.map(emStat => (
                                                    <option key={emStat.value} value={emStat.value}>{emStat.label}</option>
                                                ))}
                                            </select>
                                        }
                                    </div>
                                </div>
                            </div>
                            {i == 0 ? <div className="row">
                                <div className="col-sm-4">
                                    <div className="form-group">
                                        <div>
                                            <label>Other Source of Income <small className="red">(required)</small></label>
                                            <Select
                                                onChange={that.onSelect}
                                                name="Other_Source_of_Income__c"
                                                id={`Hou${i}[Other_Source_of_Income__c]`}
                                                type="text"
                                                multi
                                                simpleValue
                                                options={props.data.OtherSourceIncList}
                                                value={props.data.Other_Source_of_Income__c}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-4">
                                    <div className="form-group">
                                        <div>
                                            <label>Occupation {props.data.Employment_Status__c !== 'Unemployed' && <small className="red">(required)</small>}</label>
                                            <input
                                                onChange={this.handleInputChange}
                                                name="Occupation__c"
                                                id={`Hou${i}[Occupation__c]`}
                                                type="text"
                                                className="form-control select"
                                                value={props.data.Employment_Status__c === 'Unemployed' ? '' : props.data.Occupation__c}
                                                disabled={props.data.Employment_Status__c === 'Unemployed'}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-4">
                                    <div className="form-group">
                                        <div>
                                            <label>Company {props.data.Employment_Status__c !== 'Unemployed' && <small className="red">(required)</small>}</label>
                                            <input
                                                onChange={this.handleInputChange}
                                                name="Company__c"
                                                id={`Hou${i}[Company__c]`}
                                                type="text"
                                                className="form-control"
                                                value={props.data.Employment_Status__c === 'Unemployed' ? '' : props.data.Company__c}
                                                disabled={props.data.Employment_Status__c === 'Unemployed'}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div> :
                                <div className="row">
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <div>
                                                <label>Occupation {props.data.Hou[i].data.Employment_Status__c !== 'Unemployed' && <small className="red">(required)</small>}</label>
                                                <input
                                                    onChange={this.UpdateHou}
                                                    name="Occupation__c"
                                                    id={`Hou${i}[Occupation__c]`}
                                                    type="text"
                                                    className="form-control select"
                                                    value={props.data.Hou[i].data.Employment_Status__c !== 'Unemployed' ? props.data.Hou[i].data.Occupation__c : ''}
                                                    disabled={props.data.Hou[i].data.Employment_Status__c === 'Unemployed'}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <div>
                                                <label>Company {props.data.Hou[i].data.Employment_Status__c !== 'Unemployed' && <small className="red">(required)</small>}</label>
                                                <input
                                                    onChange={this.UpdateHou}
                                                    name="Company__c"
                                                    id={`Hou${i}[Company__c]`}
                                                    type="text"
                                                    className="form-control"
                                                    value={props.data.Hou[i].data.Employment_Status__c !== 'Unemployed' ? props.data.Hou[i].data.Company__c : ''}
                                                    disabled={props.data.Hou[i].data.Employment_Status__c === 'Unemployed'}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>}
                            <div className="row">
                                <div className="col-sm-4">
                                    <div className="form-group">
                                        {i === 0 ?
                                            <div>
                                                <label>
                                                    Other Source of Income Amount
                                                    {this.props.data.Other_Source_of_Income__c === 'None' ||
                                                        this.props.data.Other_Source_of_Income__c === '' ?
                                                        '' : <small className="red">(required)</small>
                                                    }
                                                </label>
                                                <input
                                                    onChange={this.handleInputChange}
                                                    name="Other_Source_of_Income_Amount__c"
                                                    id={`Hou${i}[Other_Source_of_Income_Amount__c]`}
                                                    type="text"
                                                    className="form-control"
                                                    value={props.data.Other_Source_of_Income_Amount__c}
                                                    disabled={this.props.data.Other_Source_of_Income__c === 'None'}
                                                />
                                            </div> : ''
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-4">
                                    <div className="form-group">
                                        <label>Upload NRIC/Birth Cert File</label><br />
                                        <label className="fileContainer">
                                            Choose File
                                            <input
                                                onChange={that.uploadHouFile}
                                                onClick={(e) => { e.target.value = null; }}
                                                type="file"
                                                name="file1"
                                                className="form-control-file"
                                                id={`Hou${i}[nric_fin_file]`}
                                                aria-describedby="fh1"
                                            />
                                        </label>
                                        <br />
                                        &nbsp;
                                        <span id={`file1Name${i}`} style={{ fontSize: '10pt', fontWeight: 'bold' }}>
                                            {props.data.Hou[i].attachment.file1 ? props.data.Hou[i].attachment.file1.Name : ''}
                                        </span>
                                        <i
                                            id={`Hou${i}[file1Name]`}
                                            className="fa fa-times-circle"
                                            onClick={that.removeFile}
                                        />
                                        <br />
                                        <label>
                                            <small id="fileHelp1" className="form-text text-muted">format: jpg, png, pdf only </small>
                                        </label>
                                    </div>
                                </div>
                                <div className="col-sm-4">
                                    <div className="form-group">
                                        <label>
                                            Upload Past 6 Months CPF Statement
                                        </label>
                                        <br />
                                        <label className="fileContainer">
                                            Choose File
                                            <input
                                                onChange={that.uploadHouFile}
                                                onClick={(e) => { e.target.value = null; }}
                                                name="file2"
                                                type="file"
                                                className="form-control-file"
                                                id={`Hou${i}[cpmf_statement]`}
                                                aria-describedby="gh1"
                                            />
                                        </label>
                                        <br />
                                        &nbsp;
                                        <span id={`file2Name${i}`} style={{ fontSize: '10pt', fontWeight: 'bold' }}>
                                            {props.data.Hou[i].attachment.file2 ? props.data.Hou[i].attachment.file2.Name : ''}
                                        </span>
                                        <i
                                            id={`Hou${i}[file2Name]`}
                                            name="file2"
                                            className="fa fa-times-circle"
                                            onClick={that.removeFile}
                                        />
                                        <br />
                                        <label>
                                            <small id="gh1" className="form-text text-muted">format: jpg, png, pdf only </small>
                                        </label>
                                    </div>
                                </div>
                                <div className="col-sm-4">
                                    <div className="form-group">
                                        {i === 0 ?
                                            <label>Upload latest payslip {props.data.Employment_Status__c !== 'Unemployed'}</label>
                                            :
                                            <label>Upload latest payslip {props.data.Hou[i].data.Employment_Status__c !== 'Unemployed'}</label>
                                        }
                                        <br />
                                        <label className="fileContainer">
                                            Choose File
                                            <input
                                                onChange={that.uploadHouFile}
                                                onClick={(e) => { e.target.value = null; }}
                                                type="file"
                                                name="file3"
                                                className="form-control-file"
                                                id={`Hou${i}[payslip]`}
                                                aria-describedby="fh1"
                                            />
                                        </label>
                                        <br />
                                        &nbsp;
                                        <span id={`file3Name${i}`} style={{ fontSize: '10pt', fontWeight: 'bold' }}>
                                            {props.data.Hou[i].attachment.file3 ? props.data.Hou[i].attachment.file3.Name : ''}
                                        </span>
                                        <i
                                            id={`Hou${i}[file3Name]`}
                                            name="file2"
                                            className="fa fa-times-circle"
                                            onClick={that.removeFile}
                                        />
                                        <br />
                                        <label>
                                            <small id="fileHelp1" className="form-text text-muted"> format: jpg, png, pdf only </small>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                }) */}
                <br />
                <center>
                    <button onClick={this.addCount} className="btn btn-primary">Add more household member</button>
                </center>
                <br />
            </div>
        );
    }
}

Tab4.propTypes = {
    title: PropTypes.string,
    maritalStatus: PropTypes.string,
};
Tab4.defaultProps = {
    title: 'Tab4 ',
};


const mapDispatchToProps = dispatch => ({

});

const mapStateToProps = state => ({
    user: state.user,
});

export default connect(mapStateToProps, mapDispatchToProps)(Tab4);



//////////////////
// WEBPACK FOOTER
// ./src/components/Registration/tab4.js
// module id = 1048
// module chunks = 0